import React from 'react';
import LanguageContextProvider from './src/components/language-context-provider';


export const wrapRootElement = ({ element }) => (
  <LanguageContextProvider>{element}</LanguageContextProvider>
);
